// extracted by mini-css-extract-plugin
export var alts = "img_grid-module--alts--6bfcd";
export var arrow_right = "img_grid-module--arrow_right--a2eb3";
export var arrows = "img_grid-module--arrows--974c5";
export var curr = "img_grid-module--curr--41696";
export var gallvid = "img_grid-module--gallvid--9ddc2";
export var grid = "img_grid-module--grid--927e1";
export var grid_count = "img_grid-module--grid_count--e1275";
export var grid_counttxt = "img_grid-module--grid_counttxt--b686d";
export var grid_img = "img_grid-module--grid_img--d3358";
export var hovoff = "img_grid-module--hovoff--9f1f4";
export var image = "img_grid-module--image--7be67";
export var img_grid = "img_grid-module--img_grid--304f7";
export var ind_dot = "img_grid-module--ind_dot--e8182";
export var indicate = "img_grid-module--indicate--fd5f3";
export var off = "img_grid-module--off--cee42";
export var on = "img_grid-module--on--6e01d";
export var show = "img_grid-module--show--77ced";
export var tile_grid = "img_grid-module--tile_grid--b84bd";
export var tile_vid = "img_grid-module--tile_vid--6e2d7";